import { useQuery } from "@tanstack/react-query";
import { ListDepartmentsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useDepartmentNames = (projectId: string) => {
  const { getToken } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.departmentNames(projectId),
    queryFn: async (): Promise<string[]> => {
      const token = await getToken();

      if (!token) {
        throw new Error("No access token available.");
      }

      const response = await fetch(`/api/projects/${projectId}/departments`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Group names could not be fetched");
      }
      const { departmentNames } = ListDepartmentsResponse.parse(
        await response.json(),
      );
      return departmentNames;
    },
    initialData: [],
  });
};
